module.exports = __webpack_public_path__ + "static/TableBG-d42d9ace89edaf61023e863f173a1f04.jpg";